import React from "react";
const VodTempPlayer = React.memo(({ playerUrl }) => {
    return (React.createElement("div", { style: { paddingTop: '8px' } },
        React.createElement("iframe", { src: playerUrl, width: 500, height: 500 })));
});
export { VodTempPlayer };
